import React from 'react'
import StarRatings from '../../StarRatings/StarRatings'

const BASE_CONTAINER_CLASS =
  'flex h-4 flex-row gap-x-1.5 leading-4 items-center'

const ReviewStars = ({ reviewAverage = 0, reviewLength = 0, slug }) => {
  if (reviewLength < 1) {
    return null
  }

  const starRatingProps = {
    starRatedColor: '#FFBC4A',
    starSpacing: '1px',
    rating: reviewAverage,
    uniqueKey: slug,
    starRatingsStyle: 'flex items-center',
    svgIconViewBox: '0 0 13 12',
    svgIconPath:
      'M11.5 4.241H7.73L6.477.31a.522.522 0 0 0-.954 0L4.27 4.241H.5a.5.5 0 0 0-.3.9l3.01 2.3-1.26 3.867a.5.5 0 0 0 .77.559L6 9.481l3.28 2.383a.5.5 0 0 0 .77-.559L8.794 7.442l3.01-2.3a.5.5 0 0 0-.3-.9l-.004-.001Z'
  }

  return (
    <>
      <div className={`${BASE_CONTAINER_CLASS} hidden sm:flex`}>
        <div className="mt-[-3px] h-[14px]">
          <StarRatings
            {...starRatingProps}
            numberOfStars={5}
            starDimension="15px"
          />
        </div>
        <span className="h-[11px] text-[11px] font-normal leading-[11px] text-gray-800">
          {`(${reviewLength})`}
        </span>
      </div>
      <div className={`${BASE_CONTAINER_CLASS} sm:hidden`}>
        <div className="-mt-1.5 h-[14px]">
          <StarRatings
            {...starRatingProps}
            numberOfStars={1}
            starDimension="18px"
          />
        </div>
        <span className="h-[14px] text-[11px] font-semibold text-gray-800">
          {`${reviewAverage.toFixed(1)}`}{' '}
          <span className="pl-px font-normal text-gray-700">
            ({reviewLength})
          </span>
        </span>
      </div>
    </>
  )
}

export default ReviewStars
